import React from 'react';

const Hero = () => {
  return (
    <section className="py-16 md:py-24 max-w-2xl mx-auto">
      <div className="space-y-4">
        <p className="font-serif text-2xl md:text-3xl text-foreground/90 leading-snug">
          Building software and the teams behind it.
        </p>

        <p className="font-serif text-lg md:text-xl text-muted-foreground leading-relaxed italic">
          From code to teams, built to scale.
        </p>
      </div>

      <div className="mt-10 max-w-lg">
        <p className="font-sans text-base md:text-lg text-foreground/70 leading-relaxed mb-4">
          I'm a software engineer with a solid technical foundation and a global background across multiple roles and industries.
        </p>
        <p className="font-sans text-base md:text-lg text-foreground/70 leading-relaxed">
          As Co-Founder and CTO of Enabl, <span className="font-semibold text-foreground">I focus on engineering excellence, scalable systems, and building teams that deliver consistently.</span>
        </p>
      </div>

      <div className="mt-12 flex items-center gap-4">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
          </span>
          <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
            Building enabl.ai
          </span>
        </div>
        <span className="text-muted-foreground/30 text-xs">/</span>
        <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">
          Seed Stage
        </span>
      </div>
    </section>
  );
};

export default Hero;